"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require(".");
var _util = require("../../util");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var MainSection = function MainSection(_ref) {
  var _o$data, _otherOffers$data;
  var productType = _ref.productType,
    offers = _ref.offers,
    constants = _ref.constants,
    register = _ref.register;
  if (!offers.length) return null;
  var bem = (0, _util.bemClass)('revision-offers');
  var offerList = transform(offers);
  var _getCardProps = getCardProps(),
    o = _getCardProps.offers,
    otherOffers = _getCardProps.otherOffers;
  var hasOffers = (o === null || o === void 0 ? void 0 : (_o$data = o.data) === null || _o$data === void 0 ? void 0 : _o$data.length) > 0;
  var hasOtherOffers = (otherOffers === null || otherOffers === void 0 ? void 0 : (_otherOffers$data = otherOffers.data) === null || _otherOffers$data === void 0 ? void 0 : _otherOffers$data.length) > 0;
  var hasSingleOffer = +hasOffers + +hasOtherOffers === 1;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "revision-offers"
  }, /*#__PURE__*/_react.default.createElement(_.OfferHeader, {
    productType: productType
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: bem('cards', hasSingleOffer ? 'cards--single' : '')
  }, hasOffers && /*#__PURE__*/_react.default.createElement(_.Card, {
    offers: o.data,
    productType: o.type,
    constants: constants,
    register: register
  }), hasOtherOffers && /*#__PURE__*/_react.default.createElement(_.Card, {
    offers: otherOffers.data,
    productType: otherOffers.type,
    constants: constants,
    register: register
  })));
  function getCardProps() {
    if (_util.ADS_PRODUCTS.includes(productType)) return {
      offers: {
        data: (0, _util.filterOffers)(offerList, _util.PRODUCT_TYPES.IF),
        type: _util.PRODUCT_TYPE_ABBR.INTEREST_FREE_LOAN
      },
      otherOffers: {
        data: (0, _util.filterOffers)(offerList, _util.PRODUCT_TYPES.PRP),
        type: _util.PRODUCT_TYPE_ABBR.PROMOTIONAL_RATE_PLAN
      }
    };
    if (_util.LC_PRODUCTS.includes(productType)) return {
      offers: {
        data: (0, _util.filterOffers)(offerList, _util.PRODUCT_TYPES.LCFRP),
        type: _util.PRODUCT_TYPE_ABBR.LC_FIXED_RATE_PLAN
      },
      otherOffers: {
        data: (0, _util.filterOffers)(offerList, _util.PRODUCT_TYPES.LCTNI),
        type: _util.PRODUCT_TYPE_ABBR.LC_TRUE_NO_INTEREST
      }
    };
    return {};
  }
};
MainSection.propTypes = {
  productType: _propTypes.default.string.isRequired,
  offers: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  constants: _propTypes.default.shape().isRequired,
  register: _propTypes.default.func.isRequired
};
function transform(offers) {
  return offers.map(function (o) {
    return _objectSpread(_objectSpread({}, o), {}, {
      productTerm: o.term,
      loanAmount: (0, _util.toDollar)(o.amount),
      totalCost: (0, _util.toDollar)(o.totalCost),
      minMonthlyPayments: (0, _util.toDollar)(o.monthlyPayment),
      minimumApr: "".concat(o.intRate, "%"),
      minimumAmount: (0, _util.toDollar)(o.minimumAmount),
      maximumAmount: (0, _util.toDollar)(o.maximumAmount)
    });
  });
}
var _default = MainSection;
exports.default = _default;
